import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IAbstractView, ILanguageObject } from '@core/interfaces';
import { NotePresenter } from './singleproduct-note.presenter';
import { INoteComponent } from './interfaces';

@Component({
  selector: 'app-singleproduct-note',
  templateUrl: './singleproduct-note.component.html',
  styleUrls: ['./singleproduct-note.component.scss'],
  standalone: false,
  providers: [NotePresenter]
})
export class NoteComponent 
  extends IAbstractView<NotePresenter> 
  implements INoteComponent 
{
  @Input() formGroup!: FormGroup;
  @Input() translations: ILanguageObject = {} as ILanguageObject;

  constructor(presenter: NotePresenter) {
    super(presenter);
  }
}
